import { Component, OnInit, Output, Input, EventEmitter, HostListener, ElementRef, SimpleChanges, ChangeDetectionStrategy, ViewChild, AfterViewInit, OnDestroy, OnChanges, ChangeDetectorRef } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { SearchPipe } from '../pipes/search.pipe';
import { fromEvent, Observable, Subscription } from 'rxjs';
import * as _ from 'lodash';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { TranslatePipe } from '../pipes/translate.pipe';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DropdownComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
	@ViewChild('theInput', { static: false }) theInput: ElementRef;
	@Input() appModel: any;
	@Input() list: any = [];
	@Input() value: string = null;
	@Input() useTrackBy: boolean = false;
	@Input() name: string = null;
	@Input() placeholder: string = null;
	@Input() required: boolean = null;
	@Input() backTranslate: boolean = null;
	@Input() toCreate: boolean = null;
	@Input() multiple: boolean = null;
	@Input() debug: boolean = null;
	@Input() showEmpty: boolean = null;
	@Input() color: boolean = null;
	@Input() disabled: boolean = null;

	@Input() createValue: string = null;
	@Input() uppercase: boolean = null;
	@Input() keepOpen: boolean = true;
	@Input() showCheckboxOptions: boolean = false;
	@Input() returnObj: boolean = false;
	@Input() posRelative: boolean = false;
	@Input() showSlideToggle: boolean = false;
	@Input() toggleSlideKey: string = '';

	@Output() appModelChange = new EventEmitter<string>();
	@Output() createValueChange = new EventEmitter<string>();
	@Output() appChange = new EventEmitter<string>();
	@Output() onClose = new EventEmitter<string>();
	@Output() returnObject = new EventEmitter<any>();
	@Output() onChangeModel = new EventEmitter<any>();


	filteredList: any[] = [];
	inputValue: string;
	searchvalue: string;

	showOptions: boolean = false;
	wasInside: boolean = false;
	itemWasSelected: boolean = false;
	firstOpen: boolean = false;
	wasClickNav: boolean = false;
	local: any;

	sliceStart: number = 0
	sliceLength: number = 25
	sliceEnd: number = this.sliceLength
	selected_color: any[] = [];

	$documentClick: Observable<Event>;
	$inputClick: Observable<Event>;
	subs: Subscription[] = [];


	clickEmpty() {
		this.appModel = undefined
		this.appModelChange.emit(this.appModel);
	}
	
	toggleSlideStatus($event: MatSlideToggleChange, element) {
		const isChecked = !$event.checked;
		const elementIndex = this.appModel.findIndex((el) => el.id === element.id);
		if (elementIndex !== -1) {
		  if(this.appModel.length === 0 ) this.appModel = this.local.characters;
		  this.appModel[elementIndex][this.toggleSlideKey] = isChecked;
		  this.appModelChange.emit(this.appModel);
		}
	
		if (this.local && this.local.characters) {
		  const elementInLocal = this.local.characters.find(e => e.id === element.id);
		  if (elementInLocal) {
			elementInLocal.include = elementInLocal.include === null ? !isChecked : isChecked;
			localStorage.setItem('Scnenefilter', JSON.stringify(this.local));
		  }
		}
	  }

	  getSlideCheckStatus(element) {
		if (this.local && this.local.characters) {
		  const elementInLocal = this.local.characters.find(e => e.id === element.id);
		  if (elementInLocal) {
			return !elementInLocal.include;
		  }
		}
		return false;
	  }

	moveSlice(ev, element) {
		this.wasClickNav = true;
		element.scrollTop = 0;

		if (ev == 'next') {
			this.sliceStart += this.sliceLength;
			this.sliceEnd += this.sliceLength;
		} else {
			this.sliceStart -= this.sliceLength;
			this.sliceEnd -= this.sliceLength;
		}
		if (this.keepOpen) {
			setTimeout(() => {
				this.showOptions = true;
				this.itemWasSelected = false;
				this.cancelSubscriptions();
				this.initSubscriptions();
			}, 100)
		}
	}

	resetDropdown() {
		this.firstOpen = true;
		this.showOptions = true;
		this.itemWasSelected = false;
		this.cancelSubscriptions();
		this.initSubscriptions();
	}

	search() {
		this.searchvalue = this.inputValue;
		var a = this.name;
		if (this.backTranslate) {
			a = this.name + '_' + this._gS.getLenguage()
		}
		
		if (this.list == undefined || this.list == null)
			this.filteredList = [];
		else 
			this.filteredList = this.list;
		
		this.filteredList = this._SearchPipe.transform(this.filteredList, this.searchvalue, a);
		
		if (!this.searchvalue) {
			this.filteredList = this.list;
		}

		if (this.toCreate) {
			var found = [];
			var a = this.backTranslate ? (this.name + '_' + this._gS.getLenguage()) : this.name;
			var b = this.searchvalue
			found = this.filteredList.find(function (element) {
				return element[a].toLowerCase() == b.toLowerCase();
			});
			if (found) {
				this.createValue = undefined;
			} else {
				this.createValue = this.searchvalue;
				this.appModel = undefined;
				this.appModelChange.emit(this.appModel);
			}
			this.createValueChange.emit(this.createValue);
		}
	}
	startDropDown() {
		if (this.list == undefined || this.list == null)
			this.filteredList = [];
		else 
			this.filteredList = this.list;

		this.resetDropdown();
		this.searchvalue = '';
		// this.inputValue = '';

	}
	evaluateIncludeInOption(option){
		const evaluatedOption = this.appModel.find((el) => el.id === option.id);
		return evaluatedOption ? evaluatedOption.include : true;		
	}
	getName(ev: string) {
		if (this.backTranslate) {
			return ev[this.name + '_' + this._gS.getLenguage()];
		}
		if(this.showSlideToggle && !this.evaluateIncludeInOption(ev)) {
			return this._ts.transform("Whitout").toUpperCase()  + " " + ev[this.name];
		}
		return ev[this.name];
	}
	selectOption(ev, isFromBlur = false) {
		if (this.color) {
			this.selected_color = ev;
		}
		if (!this.multiple) {
			this.appModel = this.getValue(ev);
			this.inputValue = this.getName(ev);
			this.appModelChange.emit(this.appModel);
			this.appChange.emit(ev);
			this.showOptions = false;
			this.wasInside = false;
			this.itemWasSelected = this.wasClickNav && isFromBlur ? false : true;
			this.wasClickNav = false;
			if (this.returnObj) {
				this.returnObject.emit(ev);
			}
			if (this.toCreate) {
				this.createValue = undefined;
				this.createValueChange.emit(this.createValue);
			}
		} else {
			if (ev.selected) {
				ev.selected = false
			} else {
				ev.selected = true
			}
			if (ev.selected) {
				this.appModel.push(ev);

			} else {
				var i = 0
				for (let sel of this.appModel) {
					if (sel[this.value] == ev[this.value]) {
						this.appModel.splice(i, 1);
					}
					i++
				}
			}
			this.appModelChange.emit(this.appModel);
			this.checkMultipleText();
		}

	}
	selectModel(opt) {
		if (!this.multiple) this.onChangeModel.emit(opt);
	}
	checkMultipleText() {
		var a = []
		this.inputValue = ''
		for (let obj of this.appModel) {
			a.push(this.getName(obj));
		}
		this.inputValue = a.join(', ')
	}
	blur() {
		if (!this.multiple) {
			if (!this.toCreate) {
				this.executeBlur();
			} else {
				var found = [];
				var a = this.backTranslate ? (this.name + '_' + this._gS.getLenguage()) : this.name;
				var b = this.searchvalue

				if (this.list == undefined || this.list == null)
					this.filteredList = [];
				else 
					this.filteredList = this.list;

				found = this.filteredList.find(function (element) {
					var c = element[a]
					if (c) {
						return c.toLowerCase() == b.toLowerCase();
					} else {
						return ''
					}

				});
				if (found) {
					this.createValue = undefined;
					this.selectOption(found, true);
					this.executeBlur()
				}
			}
		}
	}
	executeBlur() {
		setTimeout(() => {
			if (!this.wasClickNav) {
				this.showOptions = false;
				this.cancelSubscriptions();

				if (this.appModel) {
					var a = this.value
					var c = this.appModel
					var found = this.list.find(function (element) {
						return element[a] == c;
					});
					this.selectOption(found)
				}
			}
			this.wasClickNav = false;
		}, 100);
	}
	getValue(ev) {
		return ev[this.value];
	}
	setChange() {
		if (this.multiple) {
			var a = []
			if (this.appModel) {
				if (this.appModel.length > 0) {
					for (let item of this.list) {
						item.selected = false;
						for (let obj of this.appModel) {
							if (item[this.value] == obj[this.value]) {
								item.selected = true;
								if (this.showCheckboxOptions) {
									item.isExcluded = obj.isExcluded;
								}
								a.push(item)
							}
						}
					}
				} else {
					for (let item of this.list) {
						item.selected = false;
					}
				}
			}
			this.appModel = a;
			this.appModelChange.emit(this.appModel);
			this.checkMultipleText();
		} else {
			if (this.appModel) {
				for (let item of this.list) {
					if (this.getValue(item).toString() == this.appModel.toString()) {
						this.selectOption(item)
					}
				}
			}
		}
		if (this.list == undefined || this.list == null)
			this.filteredList = [];
		else 
			this.filteredList = this.list;
	}

	trackBy(index, item) {
		return item[this.value];
	}

	toggleWithoutOption(event, option) {
		event.stopPropagation();
		option.isExcluded = !option.isExcluded;
	}

	constructor(
		private _elementRef: ElementRef,
		public _gS: GlobalService,
		private _SearchPipe: SearchPipe,
		private _cD: ChangeDetectorRef,
		private _ts: TranslatePipe) { }

	initSubscriptions() {
		this.subs.push(this.$inputClick.subscribe(data => {
			this.showOptions = !this.itemWasSelected ? true : false;
			this.wasInside = !this.itemWasSelected ? true : false;
			this.itemWasSelected = false;
		}));
		this.subs.push(this.$documentClick.subscribe(data => {
			if (!this.wasInside) {
				this.showOptions = false;
				this.cancelSubscriptions();
				this.onClose.emit();
				this._cD.detectChanges();
			}
			this.wasInside = this.firstOpen && !this.multiple ? true : false;
			this.firstOpen = false;
		}));
	}

	cancelSubscriptions() {
		this.subs.map(s => s.unsubscribe());
	}

	ngOnChanges(changes: SimpleChanges) {
		if (!this.multiple) {
			if (changes.appModel && !changes.firstChange) {
				if (changes.appModel.currentValue != changes.appModel.previousValue) {
					if (changes.appModel.currentValue == undefined || changes.appModel.currentValue == '') {
						this.inputValue = '';
					} else if (changes.appModel.previousValue == '' || changes.appModel.previousValue == undefined || changes.appModel.previousValue) {
						for (let itm of this.list) {
							if (changes.appModel.currentValue == itm[this.value]) {
								this.selectOption(itm)
							}
						}
					}
				}
			}
		} else {
			if (changes.appModel && !changes.firstChange) {
				if (changes.appModel.currentValue != changes.appModel.previousValue) {
					if (changes.appModel.currentValue.length == 0) {
						if (this.list) {
							this.inputValue = '';
							for (let item of this.list) {
								item.selected = false;
							}
						}

					} else {
						let prev = changes.appModel.previousValue || [];
						let isDifferent = _.xorWith(prev, changes.appModel.currentValue, _.isEqual).length > 0;
						if (isDifferent) {
							this.setChange();
						}
					}

				}
			}
		}

		if (changes.list) {
			if (!changes.list.firstChange) {
				this.sliceStart = 0
				this.sliceEnd = this.sliceLength;
				if (this.list == undefined || this.list == null)
					this.filteredList = [];
				else 
					this.filteredList = this.list;
			}
		}
	}

	ngOnInit() {
		this.local = JSON.parse(localStorage.getItem('Scnenefilter') || '{}');
		this.setChange();
	  }

	ngAfterViewInit() {
		this.$documentClick = fromEvent(document, 'click');
		this.$inputClick = fromEvent(this.theInput.nativeElement, 'click');
	}

	ngOnDestroy() {
		this.cancelSubscriptions();
		this.local = JSON.parse(localStorage.getItem('Scnenefilter') || '{}')
	}

}
